import React from 'react';

function BannerContact() {
  return (
    <section className='banner-contact'>
        <div className='banner-caption-sec'>
            <div className='container'>
                <div className='caption-banner'>
                    <div className='ban-caption'>
                        <h4 className='big-ttl'>Contact Choice Techlab</h4>
                        <p className='sm-para'>We're excited to connect with you. Reach out to us for inquiries, collaborations, or to start your product innovation journey.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default BannerContact;
